import React, {useEffect, useState} from 'react';
import { trackPromise } from "react-promise-tracker";
import { Editor } from "@tinymce/tinymce-react";

interface DommusTagsEditorProps {
    handleEditorChange: (content: string) => void
    content: string 
    tagsGroup: object,
    height?: number,
    utilizarDommusTag?: boolean,
    assinatura?: string
}

export function DommusTagsEditor({handleEditorChange, content, tagsGroup, height=200, utilizarDommusTag=true, assinatura}: DommusTagsEditorProps){
  const [opcoesTinyMce, setOpcoesTinyMce] = useState(null as any);
  const gerarItensMenu =  (dependencias: any, editor: any) => {
      var lerTagsGrupo = function (arrayTags: any[]) {
          arrayTags = arrayTags.sort((a,b) => (a.rotulo < b.rotulo) ? -1 : 1);
          let retorno = [] as any[];
          for (let tag of arrayTags) {

              retorno.push({
                  type: 'menuitem',
                  text: tag.rotulo,
                  onAction: function () {
                      editor.insertContent('<span class="mceNonEditable">' + tag.tag.toString() + '</span>');
                  }
              });
          }
          return retorno;
      };

      var lerSubgrupos = function (subgrupos: any[]) {
        subgrupos = subgrupos.sort((a,b) => (a.rotulo < b.rotulo) ? -1 : 1);

          let items = [] as any[];
          for (let subgrupo in subgrupos) {
              let objetoSubgrupo = subgrupos[subgrupo];
              if(!(objetoSubgrupo.tags || false)){
                  console.log(objetoSubgrupo);
              }
              items.push({
                  type: 'nestedmenuitem',
                  text: objetoSubgrupo.rotulo,
                  getSubmenuItems: () => {
                      return lerTagsGrupo(objetoSubgrupo.tags);
                  }
              });
          }

          return items;
      };

      let items = [] as any[];
      for (let grupo in dependencias) {
          let objetoGrupo = dependencias[grupo];
          let itemGrupo = {
              type: 'nestedmenuitem',
              text: objetoGrupo.rotulo
          } as any;

          if (objetoGrupo.subgrupos || false) {
              itemGrupo.getSubmenuItems = () => {
                  return lerSubgrupos(objetoGrupo.subgrupos);
              };
          }
          if (objetoGrupo.tags || false) {
              itemGrupo.getSubmenuItems = () => {
                  return lerTagsGrupo(objetoGrupo.tags);
              };
          }
          items.push(itemGrupo);
      }
      items = items.sort((a,b) => (a.text < b.text) ? -1 : 1 );

      return items;
  };

  useEffect(() => {
    setOpcoesTinyMce(null);
    const redefinirOpcoes = new Promise((resolve) => {
      setTimeout(()=>{
        const novasOpcoes = {
          promotion: false,
          branding: false,
          language: "pt_BR",
          entity_encoding: "raw",
          selector: "textarea#templateTitle",
          height: height,
          menubar: "file edit insert view format table tools help",
          plugins: [
            "advlist", "autolink", "lists", "link", "image",
            "charmap", "print", "preview", "anchor", "help",
            "searchreplace", "visualblocks", "code",
            "insertdatetime", "media", "table", "paste", "wordcount",
          ],
          setup: (editor: any) => {
            if(utilizarDommusTag) {
              editor.ui.registry.addMenuButton('dommustags', {
                text: 'DommusTags',
                fetch: (callback: any) => {
                  callback(gerarItensMenu(tagsGroup, editor));
                }
              });
            }

            if(assinatura){
              editor.ui.registry.addButton("assigne", {
                tooltip: "Adjust Layout",
                icon: "edit-block",
                text: "Assinar",
                onAction: () => editor.insertContent(assinatura),
              });
            }
          },
          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          toolbar: `${utilizarDommusTag ? 'dommustags' : ''} | fontsize | fontfamily | styles | image | formatselect | bold italic | alignleft aligncenter alignright justify | outdent indent | bullist numlist | table | fontselect fontsizeselect | link | code | undo redo ${assinatura ? '| assigne' : ''}`
        };
        setOpcoesTinyMce(novasOpcoes);
        resolve(novasOpcoes);
      }, 3000);
    });
    trackPromise(redefinirOpcoes.then());

  }, [tagsGroup]);

  return opcoesTinyMce && <Editor
    tinymceScriptSrc='/tinymce/tinymce.min.js'
    licenseKey='gpl'
    initialValue={content}
    init={opcoesTinyMce}
    onChange={(event)=>{
      handleEditorChange(event?.target?.getContent()??"");
    }}
    disabled={false}
  />
};
